/**
 * POSTLAUNCH-V5 · P0-#5 (Fr 04.09.2026) — Versionshinweis am unteren Rand.
 * POSTLAUNCH-V6 · Update Andreas 07:30 — Datum raus, dafür trackbare Build-ID.
 *
 * Zeigt Version + Build-ID (pro Bundle-Deploy eindeutig). Klick öffnet Feedback-Modal
 * mit vorausgefüllter Versions-Info (feuert Custom-Event `f4s:feedback-open`).
 */
import React from "react";
import { MessageCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const APP_VERSION = "1.4.0";

// Build-ID: 6-stelliger Hex-Hash aus dem Bundle-Build-Timestamp.
// Wird bei jedem Vite/Webpack-Rebuild neu generiert → eindeutig pro Deploy.
// Beim Emergent-Deploy → neue ID → nachvollziehbare Zuordnung von Feedback zu Deploy.
export const APP_BUILD_ID = (() => {
  const t = Date.now();
  return t.toString(16).slice(-6).toUpperCase();
})();

export default function VersionFooter() {
  const navigate = useNavigate();
  const openFeedback = () => {
    // Pre-Launch-Final-Sprint (Do10.09.2026 18:50) — Button zeigt jetzt auf
    // die dedizierte /feedback-Route (mit Kategorie „Nachricht an Andreas").
    // Zusaetzlich Legacy-Event, damit bereits existierende Modal-Listener
    // (falls angemeldet) weiter greifen — nicht-blocking.
    window.dispatchEvent(new CustomEvent("f4s:feedback-open", {
      detail: { version: APP_VERSION, buildId: APP_BUILD_ID },
    }));
    navigate("/feedback");
  };
  return (
    <footer
      className="mt-4 pt-4 border-t border-slate-100 dark:border-slate-800 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-3 text-[11px] text-slate-500 dark:text-slate-400"
      data-testid="version-footer"
    >
      <span data-testid="version-footer-label">
        v{APP_VERSION} · Build {APP_BUILD_ID}
      </span>
      <span className="hidden sm:inline">·</span>
      <button
        type="button"
        onClick={openFeedback}
        data-testid="version-footer-feedback-btn"
        className="inline-flex items-center gap-1.5 rounded-lg px-2 py-1 hover:bg-slate-50 dark:hover:bg-slate-800/60 hover:text-slate-700 dark:hover:text-slate-200 transition-colors"
      >
        <MessageCircle className="w-3 h-3" aria-hidden="true" />
        Feedback zu dieser Version
      </button>
    </footer>
  );
}
